<template>
  <div>
    <b-media
      class="mb-md-3 bg-form-header d-flex flex-sm-row flex-column-reverse justify-content-between align-items-center p-md-2 p-1 rounded"
      no-body
    >
      <div class="d-flex justify-content-start align-items-center mt-sm-0 mt-2">
        <b-media-aside class="mr-1">
          <b-avatar size="45" class="rounded-avatar bg-secondary" />
        </b-media-aside>
        <b-media-body class="d-flex align-items-center text-white">
          <h4 class="font-weight-bolder text-white mb-0">Card preview</h4>
          <feather-icon
            icon="HelpCircleIcon"
            size="16"
            class="font-weight-bolder ml-1 rounded-circle cursor-pointer"
            v-b-tooltip.hover="'Card preview'"
          />
        </b-media-body>
      </div>
      <b-link :to="{ name: 'competitions' }">
        <span>back to the competitio list </span>
        <feather-icon icon="ChevronRightIcon"
      /></b-link>
    </b-media>
    <div class="px-5 pt-1">
      <p class="font-weight-bolder">
        This is how your competition card will look like:
      </p>
    </div>
    <div class="d-flex justify-content-center w-100 px-sm-4 px-1">
      <b-card no-body class="p-2 col-xl-8 col-lg-12 shadow-lg border">
        <b-row class="h-100 p-1 d-flex">
          <b-col
            md="7"
            cols="12"
            class="d-flex px-0 pb-0 overflow-hidden position-relative"
            style="
              background: #1b1b24 0% 0% no-repeat padding-box;
              border: 1px solid #202626;
              border-radius: 10px;
            "
          >
            <div class="w-100 d-flex flex-column align-items-center">
              <div
                class="d-flex w-100 align-items-center justify-content-between position-absolute top-0 left-0 text-white"
                :class="[`bg-remain-${calRemaining(competition).status}`]"
              >
                <div
                  :class="`p-75 px-50   bg-remain-${
                    status == 'PENDING'
                      ? 'warning'
                      : status == 'ACCEPTED'
                      ? 'success'
                      : status == 'REJECTED'
                      ? 'danger'
                      : 'warning'
                  }`"
                  style="border-radius: 0px 0px 19px 0px"
                >
                  <small>
                    {{
                      status == "PENDING"
                        ? "Pending"
                        : status == "ACCEPTED"
                        ? "Accepted"
                        : status == "REJECTED"
                        ? "Rejected"
                        : "Pending"
                    }}
                  </small>
                </div>
                <div class="py-75 px-1">
                  <small v-if="calRemaining(competition).status === 'yellow'">
                    Register is started at
                    <span
                      v-if="
                        calRemaining(competition).status === 'yellow'
                          ? (date = calRemaining(competition).time)
                          : ''
                      "
                    >
                      {{ date }}
                    </span>
                  </small>
                  <small v-if="calRemaining(competition).status === 'warning'">
                    Register is ended at
                    <span
                      v-if="
                        calRemaining(competition).status === 'warning'
                          ? (date = calRemaining(competition).time)
                          : ''
                      "
                    >
                      {{ date }}</span
                    >
                  </small>
                  <small v-if="calRemaining(competition).status === 'success'">
                    Register is ended and competition startted at
                    <span
                      v-if="
                        calRemaining(competition).status === 'success'
                          ? (date = calRemaining(competition).time)
                          : ''
                      "
                    >
                      {{ date }}</span
                    >
                  </small>
                  <small v-if="calRemaining(competition).status === 'danger'">
                    The competition is over!
                    <span
                      v-if="
                        calRemaining(competition).status === 'danger'
                          ? (date = calRemaining(competition).time)
                          : ''
                      "
                    >
                      {{ date }}</span
                    >
                  </small>
                </div>
              </div>
              <b-img
                :src="imagePreview || errorImage"
                fluid
                @error="setAltImg"
                rounded="top"
                :alt="competition.name"
                class="w-100"
                style="max-height: 260px"
              />
            </div>
          </b-col>
          <b-col
            md="5"
            cols="12"
            class="d-flex flex-column justify-content-between my-50 my-md-1"
          >
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <div class="d-flex align-items-center">
                  <div
                    class="bg-warning rounded-lg mr-50"
                    style="width: 5px; height: 14px"
                  ></div>
                  <p class="text-white mb-0">
                    {{ competition.name }}
                  </p>
                </div>

                <b-link class="text-primary text-lighten-2"
                  ><span
                    class="nowrap-white-space"
                    v-for="(broker, index) in brokers"
                    :key="index"
                    >{{ broker.text
                    }}<span v-if="brokers.length !== index + 1"> , </span></span
                  ></b-link
                >
              </div>
            </div>

            <div class="mt-50">
              <small>Open for registration - </small
              ><small
                :class="competition.active ? 'text-success' : 'text-danger'"
                >{{ competition.active ? "active" : "not active" }}</small
              >
            </div>
            <div class="mt-50 text-justify">
              <small
                v-for="(condition, index) in competition.conditions"
                :key="index"
              >
                {{ condition }}
              </small>
            </div>
            <div class="mt-50">
              <small class="font-weight-bolder"
                >Number of price places:
                {{
                  competition.awards && competition.awards.length
                    ? competition.awards.length
                    : "-"
                }}</small
              >
            </div>
            <div class="mt-50">
              <small class="font-weight-bolder"
                >Maximum number of participants:
                {{ competition.max_participant_value || "-" }}</small
              >
            </div>
            <div class="mt-50" v-if="competition.award_type == 'ABSOLUTE'">
              <small class="font-weight-bolder"
                >Total awards:
                <span class="text-success"
                  >${{ competition.award }}</span
                ></small
              >
            </div>
            <div class="mt-50">
              <small>Registration fee:</small>
            <span class="text-danger ml-50 h4 mb-0 font-weight-bold"
              >${{ competition.fee }}</span
            >
            </div>
            <b-badge class="bg-info mt-50" v-if="competition.bought">
              You already have registered the competition
            </b-badge>
            <div class="mt-50 d-flex align-items-center flex-wrap">
              <b-button
                class="px-lg-3 mr-50 gradient-btn my-50"
                v-if="
                  !competition.bought &&
                  calRemaining(competition).status === 'warning'
                "
              >
                Register
              </b-button>

              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                variant="secondary bg-lighten-1"
                class="px-lg-3 mr-50 my-50"
              >
                Rules
              </b-button>
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="secondary bg-lighten-1"
                class="btn-icon mr-50 my-50"
              >
                <feather-icon icon="Share2Icon" />
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BImg,
  BLink,
  BButton,
  BProgress,
  BSkeleton,
  BBadge,
  BMedia,
  BAvatar,
  BMediaAside,
  BMediaBody,
  BCardBody,
  BCardText,
  BCardTitle,
  BCardHeader,
  VBTooltip,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
// import { ValidationProvider, ValidationObserver } from "vee-validate";
// import Ripple from "vue-ripple-directive";
import qs from "qs";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BSkeleton,
    BCardText,
    BCardTitle,
    BCardHeader,
    BBadge,
    BButton,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BCardBody,
    BImg,
    BLink,
    BProgress,
    // ValidationProvider,
    // ValidationObserver,
  },
  props: {
    competition: {
      type: Object,
      default: () => {},
    },
    status: {
      type: String,
      default: "",
    },
    image: {
      type: null,
      default: "",
    },
  },
  computed: {
    userData() {
      return (
        this.$store.state.auth.userData ||
        JSON.parse(localStorage.getItem("userData"))
      );
    },
  },
  data() {
    return {
      propBrokers: [],
      brokers: [],
      imagePreview: "",
    };
  },
  watch: {
    image(val) {
      if (this.$route.params.id) {
        this.imagePreview = val;
      } else if (val) {
        this.imagePreview = URL.createObjectURL(val);
      }
    },
    async competition(val) {
      this.propBrokers = val.brokers;
    },
    async propBrokers(val) {
      if (val.length) {
        let conditions = [{ field: "id", operator: "in", value: [val] }];
        const { data } = await this.$http.get(`/panel/select/broker`, {
          params: { conditions },
          paramsSerializer: (params) => {
            return qs.stringify({ conditions });
          },
        });
        this.brokers = [...data.items];
      }
    },
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
};
</script>

<style></style>
